<script setup lang="ts">
    import { computed } from 'vue';
    import BulkStatusSelect from '@/components/dashboard/BulkStatusSelect.vue';
    import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
    import type { Column, Table } from '@tanstack/vue-table';
    import type { SelectOption } from '@/types';

    interface DataTableColumnHeaderWithBulkProps {
        column: Column<any, any>;
        table: Table<any>;
        title: string;
        statusOptions?: SelectOption[];
        dataFieldGroup?: string;
        reportingPeriod?: string;
    }

    const props = defineProps<DataTableColumnHeaderWithBulkProps>();

    const hasSelectedRows = computed(() => {
        return props.table.getFilteredSelectedRowModel().flatRows.length > 0;
    });
</script>

<template>
    <div class="flex flex-col gap-2">
        <BulkStatusSelect
            v-if="statusOptions && dataFieldGroup && reportingPeriod && hasSelectedRows"
            :table="table"
            :options="statusOptions"
            :data-field-group="dataFieldGroup"
            :reporting-period="reportingPeriod"
            :title="title"
        />

        <DataTableColumnHeader
            v-else
            :column="column"
            :title="title"
        />
    </div>
</template>
